import TableDataPage from '@/views/tables/TableDataPage'

export default function TableDataScreen() {
  return <TableDataPage />
}
